import React, { useEffect, Component } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
// Components
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { PodcastsPage } from './pages/PodcastsPage';
import { GuestsPage } from './pages/GuestsPage';
import { OutreachPage } from './pages/OutreachPage';
import { BookstorePage } from './pages/BookstorePage';
import { DonatePage } from './pages/DonatePage';
import { MillionMovementPage } from './pages/MillionMovementPage';
import { EndsAdventuresPage } from './pages/EndsAdventuresPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { SharePage } from './pages/SharePage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/podcasts" element={<PodcastsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/guests" element={<GuestsPage data-id="element-9" />} data-id="element-8" />
        <Route path="/outreach" element={<OutreachPage data-id="element-11" />} data-id="element-10" />
        <Route path="/bookstore" element={<BookstorePage data-id="element-13" />} data-id="element-12" />
        <Route path="/donate" element={<DonatePage data-id="element-15" />} data-id="element-14" />
        <Route path="/million-movement" element={<MillionMovementPage data-id="element-17" />} data-id="element-16" />
        <Route path="/ends-adventures" element={<EndsAdventuresPage data-id="element-19" />} data-id="element-18" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-21" />} data-id="element-20" />
        <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-23" />} data-id="element-22" />
        <Route path="/share" element={<SharePage data-id="element-25" />} data-id="element-24" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <Router data-id="element-26">
      <div className="flex flex-col min-h-screen bg-dark-700 text-dark-50 font-sans selection:bg-gold-500 selection:text-dark-900" data-id="element-27">
        <ScrollToTop data-id="element-28" />
        <Navbar data-id="element-29" />
        <main className="flex-grow" data-id="element-30">
          <AnimatedRoutes data-id="element-31" />
        </main>
        <Footer data-id="element-32" />
      </div>
    </Router>;
}